<script>
export default {
  name: "Pagination",
  props: {
    page: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 20,
    },
    pageOptions: {
      type: Array,
      default: () => [20, 50, 100],
    }
  },
  data() {
    return {
      perPageLocal: this.perPage,
      pageLocal: this.page,
    }
  },
  watch: {
    page(newVal) {
      this.pageLocal = newVal;
    },
    perPage(newVal) {
      this.perPageLocal = newVal;
    },
  }
};
</script>

<template>
  <div class="pagination-component">
    <div class="pagination-component__per-page">
      <span>Por página</span>
      <div>
        <b-form-select :value="perPageLocal" size="sm" :options="pageOptions"
          @change="(value) => $emit('perPage', value)"></b-form-select>
      </div>
    </div>
    <div class="pagination-component__items pagination-rounded">
      <b-pagination class="pagination-component__pages" v-model="pageLocal" :total-rows="total" :per-page="perPageLocal"
        @change="(value) => $emit('page', value)"></b-pagination>
    </div>
  </div>
</template>

<style lang="scss">
.pagination-component {
  display: flex;
  justify-content: flex-end;

  &__items {
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
  }

  &__pages {
    margin-bottom: 0;

    .active button,
    .active button:focus {
      background-color: #000c0b !important;
      border-color: #000c0b !important;
    }
  }

  &__per-page {
    display: flex;
    align-items: center;
    margin-right: 1rem;
    gap: 0.75rem;

    span {
      color: #000c0b;
    }
  }

  ul {

    button,
    span {
      color: #999e9d !important;
    }

    .active {

      button,
      span {
        color: #fff !important;
      }
    }

    li {
      display: flex;
      align-items: center;
    }

    li:nth-child(1) {
      font-size: 28px;
    }

    li:nth-child(2) {
      font-size: 28px;
    }

    li:nth-last-child(2) {
      font-size: 28px;
    }

    li:last-child {
      font-size: 28px;
    }
  }
}

@media (max-width: 860px) {
  .pagination-component {
    flex-direction: column-reverse;

    &__per-page {
      margin-right: 0;
      justify-content: center;
    }
  }
}

@media (max-width: 767.98px) {
  .dataTables_paginate {
    display: flex;
    justify-content: center;

    ul {
      display: flex;
      margin-top: 0px !important;
      margin-bottom: 0.25rem !important;
    }
  }
}
</style>